import { Spacer, Modal } from "@nextui-org/react";
import fetchData from "utils/fetchData";
import { useEffect, useState, useMemo } from "react";

import Table from "components/Table";
import { IoAddCircleOutline } from "react-icons/io5";
import { useNavigate } from "react-router";

const UserPanel = ({ role }) => {
  const [users, setUsers] = useState([]);
  const [visible, setVisible] = useState(false);
  const [currentDestroy, setCurrentDestroy] = useState(null);
  const navigate = useNavigate();

  const role_data = useMemo(() => {
    switch(role) {
      case 2:
        return {
          id: role,
          route: "referent",
          title: "référent"
        } 
      default:
        return {
          id: role,
          route: "client",
          title: "client"
        } 
    }
  }, [role]);

  const columns = [{ key: "name", label: "Name" }, { key: "email", label: "Email" }, { key: "actions", label: "Actions" }];

  useEffect(() => {
    const get_users = async () => {
      const { data, error } = await fetchData({
        url: `users?roles_id=${(role)}`
      });
      if (!error) setUsers(data);
    }

    get_users();
  }, [role]);

  const edit = (item) => {
    navigate(`/${role_data.route}/${item.id}`);
  }

  const destroy = (item) => {
    setCurrentDestroy(item)
  }

  const explore = (item) => {
    navigate(`/explorer/${item.id}`);
  }

  const add = async (e) => {
    e.preventDefault();
    const form = new FormData(e.target);
    form.append('roles_id', role_data.id);
    const { data, error } = await fetchData({
      url: "users", method: "post", body: form
    });
    if (error) return;

    navigate(`/${role_data.route}/${data.id}`);
  }

  const deleteClient = async (e) => {
    e.preventDefault();
    const id = currentDestroy?.id;
    if (!id) return;

    const { data, error } = await fetchData({
      url: "users/" + id, method: "delete", message: "L'utilisateur a bien été supprimé"
    });
    if (error) return;

    const new_users = [...users].filter(item => item.id !== id);
    setUsers([...new_users]);
    setCurrentDestroy(null);
  }

  return <div className="page">

    <aside>
      <button onClick={() => setVisible(true)}>
        <IoAddCircleOutline />
        <p>Ajouter un {role_data.title}</p>
      </button>
    </aside>
    <main>


      <div className="wrapper">
        <Table data={users} columns={columns} edit={edit} explore={(role_data.id === 1) ? explore : undefined} destroy={destroy} />
      </div>
    </main>

    <Modal
      closeButton
      aria-labelledby="modal-title"
      open={visible}
      onClose={() => setVisible(false)}
      className="card"
      width="600px"
      scroll
    >
      <Modal.Header>
        <h1 className="gradient" >
          Ajouter un {role_data.title}
        </h1>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={add}>
          <div className="group">
            <label>Nom</label>
            <input
                type="text"
                placeholder={"Nom du " + role_data.title}
                name="name"
                required
              />
          </div>

          <div className="group">
            <label>Email</label>
            <input
                type="text"
                placeholder={"Email du " + role_data.title}
                name="email"
                required
              />
          </div>
        
            <button style={{ alignSelf: "center"}} type="submit">Créer le {role_data.title}</button>
        </form>
      </Modal.Body>
    </Modal>


    <Modal
      closeButton
      aria-labelledby="modal-title"
      open={Boolean(currentDestroy)}
      onClose={() => setCurrentDestroy(null)}
      className="card"
      width="600px"
      scroll
    >
      <Modal.Header>
        <h1 className="gradient" >
          {"Supprimer un " + role_data.title}
        </h1>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={deleteClient}>
            <h3>Attention ! Cette action est définitive.</h3>
            <h3>Confirmez-vous la suppression de {currentDestroy?.name || ""} ?</h3>
            <Spacer />
            <span>
              <button type="button" onClick={() => setCurrentDestroy(null)}>Retour</button>
              <button className="error" type="submit">Confirmer</button>
            </span>
        </form>
      </Modal.Body>
    </Modal>
  </div>
}

export default UserPanel;